import React, { Component } from "react";
import "./NonPoItems.css";
import SideNav from "../sidenav/Sidenav.js";
import { CrfContext } from "../../CrfContext";
import { Redirect } from "react-router-dom";
import { getData, localValidation } from "./actions";
import { Transition, animated } from "react-spring/renderprops";

import NonPoItemView from "./NonPoItemView";

import axios from "axios";
import NonPoModal from "./NonPoModal";

export class NonPoItems extends Component {
  state = {
    isLoading: false,
    hasApprovedDept: false,
    userDeptList: [],

    showBanner: true,
    showForm: false,
    showPage1: false,
    showPage2: false,

    vendor: "",
    vendorError: false,
    vendorErr: 1,
    dueDate: "",
    particulars: "",
    particularsError: false,
    particularsErr: 1,
    requestingDepartment: "",
    poNumber: 1,
    poNumberError: false,
    poNumberErr: 1,
    project: "",
    projectError: false,
    projectErr: 1,
    subProject: "",
    file: null,
    fileError: false,
    fileErr: 1,

    projectClass: [
      {
        glCategory: "",
        glAccount: "",
        description1: "",
        description2: "",
        itemNumber: "",
        grossPricePerItem: 0,
        netPricePerItem: 0,
        quantity: 1,
        costType: "1OV",
        vatType: "NON-VAT",
        vatTypeValue: 1,
        wTax: 0,
        wTaxType: "X1",
        wTaxRate: "0",
        wTaxTypeValue: 0,
        wTaxTypeString: "",
        unitPrice: 0,
        subNetPrice: 0,
        projectClass: "",
        subTotalGrossPrice: 0.0,
        subTotalNetPrice: 0.0,
      },
    ],
    requestingGrossPrice: 0.0,
    requestingAmount: 0.0,
    glCategory: "",
    projectCode: "",
    vendorLists: [],
    departmentLists: [],
    projectLists: [],
    projectCode: "",
    accountTypes: [],
    itemNoList: [],

    redirect: false,
    crfId: "",

    vendorListEmpty: false,
    updateForm: false,
    advancesProjectClass: [],

    subNetList: [],

    vatTypeSelector: "",
    vatTypeSelected: "",

    wTaxRates: [],

    vendorLists: [],
    projectLists: [],

    error: 0,

    removal: false,
    target: null,
    addProjectClass: false,
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        showForm: true,
      });
    }, 500);

    // ===================================================================
    // GET VENDOR LIST
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_KEY}/api/vendors`,
      headers: {
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        // document.getElementById('main').style.display = 'block'
        console.log(response);
        this.setState({
          vendorLists: response.data.data,
        });
        console.log(this.state.vendorLists);
      })
      .catch((error) => {
        console.log(error.response);
      });

    //================================================================================

    // =========================================================

    axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_KEY}/api/userInfo`,
      headers: {
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        console.log(response);

        if (response.data.data.isProject) {
          const projectsArray = [];
          for (const obj of response.data.data.projects) {
            projectsArray.push(obj.projectName);
          }
          this.setState({
            userDeptList: response.data.data.departments,
            projectLists: projectsArray,
          });
        } else {
          this.setState({
            userDeptList: response.data.data.departments,
          });
          this.loadProjects();
        }

        let hasApproved = false;
        for (let i = 0; i < response.data.data.departments.length; i++) {
          console.log(response.data.data.departments[i].isApproved);
          if (response.data.data.departments[i].isApproved === true) {
            hasApproved = true;
          }

          if (response.data.data.roles[0] !== "Requestor") {
            this.setState({
              redirect: true,
              crfId: "/RequestSelection",
            });
          }
        }

        this.setState({
          // userRole: response.data.data.roles[0],
          // userName: response.data.data.firstName
          //  + " " + response.data.data.lastName,
          // requestingDepartment: response.data.data.department.centerName,
          // userId: response.data.data._id
        });
      })
      .catch((error) => {
        console.log(error.response);
      });
  }

  loadProjects = () => {
    // GET PROJECT LIST
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_KEY}/api/projects`,
      headers: {
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        console.log(response);
        this.setState({
          projectLists: response.data.data,
        });
      })
      .catch((error) => {
        console.log(error.response);
      });
    // =========================================================
  };

  checkStateValue = (e) => {
    e.preventDefault();
    console.log(this.state);
  };

  // END OF COMPONENT DID MOUNT

  handleChangeRequestField = (e) => {
    e.preventDefault();

    if (e.target.name === "vendor") {
      this.setState({ vendorError: true });
      axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_KEY}/api/vendors/${e.target.value}`,
        headers: {
          "Api-Key":
            "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
          Authorization: `Bearer ${localStorage.token}`,
        },
      })
        .then((response) => {
          console.log(response.data.data.bpCode);
          this.setState({
            vatTypeSelector: response.data.data.vatType,
          });
          // ==================================================================================
          // VENDOR BP CODE WILL GET THE WTAX

          axios({
            method: "GET",
            url: `${process.env.REACT_APP_API_KEY}/api/withHoldingTax/wTaxCode/${response.data.data.bpCode}`,
            headers: {
              "Api-Key":
                "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
              Authorization: `Bearer ${localStorage.token}`,
            },
          })
            .then((response) => {
              console.log(response);
              let newArray = response.data.data;
              const none = {
                wTaxCode: "X1",
                wTaxName: "",
                wTaxDisplayName: "None ",
                rate: "0",
              };
              newArray.push(none);
              this.setState({
                wTaxRates: newArray,
              });
              console.log(this.state.wTaxRates);
            })
            .catch((error) => {
              console.log(error.response);
            });

          // ==================================================================================
        })
        .catch((error) => {
          console.log(error.response);
        });

      if (
        !this.state.vendorLists.includes(
          document.getElementById(`${e.target.id}`).value
        )
      ) {
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[0].innerText =
          "Invalid Input";
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[1].innerText =
          " " + "(Please input a valid data included in the list)";
        this.setState({ vendorErr: 1 });
      } else {
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[0].innerText = "";
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[1].innerText = "";
        this.setState({ vendorErr: 0 });
      }
    }

    if (e.target.name === "dueDate") {
      this.setState({ dueDate: e.target.value });
    }

    if (e.target.name === "particulars") {
      this.setState({ particularsError: true });
      if (e.target.value === "") {
        this.setState({ particularsErr: 1 });
      } else {
        this.setState({ particularsErr: 0 });
      }
    }

    if (e.target.name === "project") {
      for (let i = 0; i < this.state.projectClass.length; i++) {
        this.setState(() => (this.state.projectClass[i].glCategory = ""));
      }
      // ================================================================================================
      this.setState({ projectError: true, projectErr: 1 });
      if (
        !this.state.projectLists.includes(
          document.getElementById(`${e.target.id}`).value
        )
      ) {
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[0].innerText =
          "Invalid Input";
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[1].innerText =
          " " + "(Please input a valid data included in the list)";
        this.setState({ projectErr: 1 });
      } else {
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[0].innerText = "";
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[1].innerText = "";
        this.setState({ projectErr: 0 });
      }

      if (e.target.value === "") {
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[0].innerText = "";
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[1].innerText = "";
        this.setState({ projectErr: 1 });
      }

      // =======================================================
    }

    if (e.target.name === "file" && e.target.files.length !== 0) {
      let fileName = e.target.files[0].name.split(".");
      let fileExtension = fileName[fileName.length - 1];
      this.setState({ fileError: true });
      console.log(e.target.file);
      console.log(fileExtension + "Asdfsdfsfdsdf");
      if (fileExtension === "pdf" || fileExtension === "PDF") {
        this.setState({ fileErr: 0 });
        console.log("error");
      } else {
        this.setState({ fileErr: 1 });
        console.log("success");
      }
    }

    if (e.target.name === "file" && e.target.files.length === 0) {
      this.setState({ fileErr: 1 });
    }

    // GET THE PARTICULAR VAT TYPE FOR SELECTED VENDOR

    // ================================================================

    // this.setState({
    //   [e.target.name]: e.target.value,
    //   requestingDepartment: document.getElementById("departmentInput").value
    // })
    // this.setState(()=> this.state.(e.target.name) = e.target.value)

    // CHANGE GL CATEGORY SELECTIONS
    // for (let i = 0; i < glCategoryClass.length; i++) {
    //   console.log('test')
    //   glCategoryClass[i].value = ""
    //   this.setState(()=> this.state.projectClass[i].glCategory = "")
    // }

    if (e.target.name === "project") {
      this.setState({
        accountTypes: [],
      });
      axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_KEY}/api/projects/${e.target.value}`,
        headers: {
          "Api-Key":
            "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
          Authorization: `Bearer ${localStorage.token}`,
        },
      })
        .then((response) => {
          console.log(response);
          this.setState({
            projectCode: response.data.data.projectCode,
          });
          console.log(this.state.projectCode);

          axios({
            method: "GET",
            url: `${process.env.REACT_APP_API_KEY}/api/glAccountTypes/${response.data.data.projectCode}`,
            headers: {
              "Api-Key":
                "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
              Authorization: `Bearer ${localStorage.token}`,
            },
          })
            .then((response) => {
              console.log(response);
              this.setState({
                accountTypes: response.data.data,
              });
              console.log(this.state.accountTypes);
            })
            .catch((error) => {
              console.log(error.response);
              this.setState({
                accountTypes: [],
              });
            });
        })
        .catch((error) => {
          console.log(error.response);
        });
    }

    if (e.target.name === "file" && e.target.files.length !== 0) {
      let fileName = e.target.files[0].name.split(".");
      let fileExtension = fileName[fileName.length - 1];
      fileExtension === "pdf" || fileExtension === "PDF"
        ? (document.getElementById("documentEmptyError").innerText = "")
        : (document.getElementById("documentEmptyError").innerText =
            "(Please upload a valid file(pdf).)");
    }

    let file = null;
    if (e.target.name === "file") {
      console.log(e.target.files[0]);
      file = e.target.files[0];
      console.log(file);
      this.setState({
        [e.target.name]: e.target.files[0],
      });
    } else {
      this.setState({
        [e.target.name]: e.target.value,
      });
    }
    console.log(this.state.accountTypes);

    this.setState({
      error:
        this.state.vendorErr +
        this.state.particularsErr +
        this.state.projectErr +
        this.state.fileErr,
    });
    console.log(this.state);
  };

  handleProjectInputFunction = (e) => {
    e.preventDefault();
    let glCategoryClass = document.getElementsByClassName("glCategoryClass");

    for (let i = 0; i < glCategoryClass.length; i++) {
      glCategoryClass[i].value = "";
    }
  };

  onBlurNumber = (e, index, key) => {
    const projectClass = [...this.state.projectClass];
    const obj = { ...projectClass[index] };
    if (e.target.value === "") {
      obj[key] = 0;
      projectClass[index] = obj;
      this.setState({
        projectClass,
      });
      return;
    }
  };

  handleWTaxRate = async (wTaxType) => {
    const { data } = await getData(`/api/withHoldingTax/wTaxRate/${wTaxType}`);
    return data.rate;
  };
  projectClassComputation = async (
    qty,
    grossPrice,
    vatType,
    wTaxType,
    projectClass,
    index,
    key
  ) => {
    const data = {
      rate: projectClass[index].wTaxRate,
    };
    if (key === "wTaxType") {
      data.rate = await this.handleWTaxRate(wTaxType);
    }
    const subTotalGrossPrice =
      (qty === "" ? 1 : parseInt(qty)) *
      parseFloat(grossPrice === "" ? 0 : grossPrice);
    const unitPrice =
      subTotalGrossPrice /
      (vatType === "VAT-X" ||
      vatType === "VAT-Z" ||
      vatType === "NON-VAT" ||
      vatType === "INT-IV"
        ? 1
        : 1.12);
    const netVat = subTotalGrossPrice - unitPrice;
    const netWTax = unitPrice * (data.rate * 0.01);
    const subTotalNetPrice = subTotalGrossPrice - netWTax;

    projectClass[index].grossPricePerItem = grossPrice;
    projectClass[index].vatType = vatType;
    projectClass[index].wTaxType = wTaxType;
    projectClass[index].wTaxRate = data.rate;
    projectClass[index].subTotalGrossPrice = subTotalGrossPrice.toFixed(2);
    projectClass[index].subTotalNetPrice =
      data.rate === "0"
        ? subTotalGrossPrice.toFixed(2)
        : subTotalNetPrice.toFixed(2);

    let requestingGrossPrice = 0.0;
    let requestingAmount = 0.0;

    for (let obj of projectClass) {
      requestingGrossPrice =
        parseFloat(obj.subTotalGrossPrice) + parseFloat(requestingGrossPrice);
      requestingAmount =
        parseFloat(obj.subTotalNetPrice) + parseFloat(requestingAmount);
    }
    console.log(requestingAmount);
    this.setState({
      projectClass,
      requestingGrossPrice: requestingGrossPrice.toFixed(2),
      requestingAmount: requestingAmount.toFixed(2),
    });
  };

  handleChangeProjectClassValue = (e, index, key) => {
    let projectClassCopy = [...this.state.projectClass];

    if (key === "customizeProjectClass") {
      projectClassCopy[parseInt(e.target.id)]["projectClass"] = e.target.value;
      if (index) {
        projectClassCopy[parseInt(e.target.id)][
          "glAccount"
        ] = `${index.accountCode} ${index.accountName} ${index.centerCode}`;
      } else {
        projectClassCopy[parseInt(e.target.id)]["glAccount"] = "";
      }
      this.setState({ projectClass: projectClassCopy });
      return;
    }

    if (
      e.target.name === "glCategory" ||
      e.target.name === "glAccount" ||
      e.target.name === "projectClass" ||
      e.target.name === "itemCode"
    ) {
      projectClassCopy[parseInt(e.target.id)][e.target.name] = e.target.value;
      this.setState({ projectClass: projectClassCopy });
    }
    if (key === "description1" || key === "description2") {
      projectClassCopy[index][key] = e.target.value.trimLeft();
      this.setState({ projectClass: projectClassCopy });
    }
    if (key === "itemCode") {
      projectClassCopy[index][key] = e.target.value.trimRight();
      this.setState({ projectClass: projectClassCopy });
    }

    if (e.target.name === "grossPricePerItem") {
      const grossPrice = e.target.value.split(".");
      if (grossPrice[0].length <= 12) {
        // projectClassCopy[parseInt(e.target.id)][e.target.name] = e.target.value
        // this.setState({projectClass: projectClassCopy})
        this.projectClassComputation(
          1,
          e.target.value,
          this.state.projectClass[index].vatType,
          this.state.projectClass[index].wTaxType,
          projectClassCopy,
          index,
          "grossPricePerItem"
        );
      }
    }
    if (e.target.name === "vatType") {
      this.projectClassComputation(
        1,
        this.state.projectClass[index].grossPricePerItem,
        e.target.value,
        this.state.projectClass[index].wTaxType,
        projectClassCopy,
        index,
        "vatType"
      );
    }

    if (e.target.name === "wTaxType") {
      this.projectClassComputation(
        1,
        this.state.projectClass[index].grossPricePerItem,
        this.state.projectClass[index].vatType,
        e.target.value,
        projectClassCopy,
        index,
        "wTaxType"
      );
    }

    // EXTRACT GL ACCOUNT NAME
    // let glAccountValue = ''
    // if (e.target.name === 'glAccount') {
    //   glAccountValue = e.target.value
    //   console.log(glAccountValue.substring(0, 10))
    //   projectClassCopy[
    //     parseInt(e.target.id)
    //   ].glAccount = glAccountValue.substring(0, 10)
    //   console.log(this.state.projectClass)
    //   this.setState({ projectClass: projectClassCopy })
    // }

    // CHANGE GL NAME LISTS
    if (e.target.value === "COC Expenses") {
      document
        .getElementById(`${parseInt(e.target.id)}`)
        .nextElementSibling.nextElementSibling.setAttribute(
          "list",
          "cocExpenses"
        );
    }

    if (e.target.value === "Advances") {
      document
        .getElementById(`${parseInt(e.target.id)}`)
        .nextElementSibling.nextElementSibling.setAttribute("list", "advances");
    }

    if (e.target.value === "OPEX") {
      document
        .getElementById(`${parseInt(e.target.id)}`)
        .nextElementSibling.nextElementSibling.setAttribute("list", "opex");
    }

    if (e.target.value === "Admin Expenses") {
      document
        .getElementById(`${parseInt(e.target.id)}`)
        .nextElementSibling.nextElementSibling.setAttribute(
          "list",
          "adminExpenses"
        );
    }

    if (e.target.value === "PPE Accounts") {
      document
        .getElementById(`${parseInt(e.target.id)}`)
        .nextElementSibling.nextElementSibling.setAttribute(
          "list",
          "ppeAccounts"
        );
    }

    if (e.target.name === "glCategory") {
      e.target.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.value =
        "";
      document.getElementById(
        `${parseInt(e.target.id)}`
      ).nextElementSibling.nextElementSibling.value = "";
      projectClassCopy[parseInt(e.target.id)].glAccount = "";
      projectClassCopy[parseInt(e.target.id)].projectClass = "";
      // CHANGE PROJECT CLASS LOOP
      // for (let i = 0; i < projectClassCopy.length; i++) {
      //   console.log('test')
      //   projectClassCopy[i].glAccount = ""
      // }
      this.setState({ projectClass: projectClassCopy });
    }

    if (e.target.name === "glCategory" && e.target.value === "Advances") {
      // e.target.nextElementSibling.nextElementSibling.nextElementSibling.style.display =
      //   'block'
      // e.target.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.style.display =
      //   'block'
    } else if (
      e.target.name === "glCategory" &&
      e.target.value !== "Advances"
    ) {
      // e.target.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.style.display =
      //   'none'
      // e.target.nextElementSibling.nextElementSibling.nextElementSibling.style.display =
      //   'none'
      // console.log(e.target.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling)
    }
  };

  addProjectClass = (e) => {
    e.preventDefault();
    this.setState({
      addedProjectClass: true,
      projectClass: [
        ...this.state.projectClass,
        {
          glCategory: "",
          glAccount: "",
          description1: "",
          description2: "",
          itemNumber: "",
          grossPricePerItem: 0,
          netPricePerItem: 0,
          quantity: 1,
          costType: "1OV",
          vatType: "NON-VAT",
          vatTypeValue: 1,
          wTax: 0,
          wTaxType: "X1",
          wTaxRate: "0",
          wTaxTypeValue: 0,
          wTaxTypeString: "",
          unitPrice: 0,
          subNetPrice: 0,
          projectClass: "",
          subTotalGrossPrice: 0.0,
          subTotalNetPrice: 0.0,
        },
      ],
    });
    // this.state.projectClass.push(
    //   {
    //           glCategory: "",
    //           glAccount: "",
    //           description1: "",
    //           description2: "",
    //           itemNumber: "",
    //           grossPricePerItem: 0,
    //           netPricePerItem: 0,
    //           quantity: 1,
    //           costType: "1OV",
    //           vatType: "",
    //           vatTypeValue: 1,
    //           wTax: 0,
    //           wTaxType:"X1",
    //           wTaxTypeValue: 0,
    //           wTaxTypeString: "",
    //           unitPrice: 0,
    //           subNetPrice: 0,
    //           projectClass: ""
    //         }
    // )
    console.log(this.state.projectClass);
  };

  localValidationProjectClasses = async (projectClasses) => {
    let validationRemarks = null;
    let countIndex = 0;
    for (const obj of projectClasses) {
      countIndex = countIndex + 1;
      if (obj.glCategory === "") {
        alert(`Project class ${countIndex}: glCategory is required`);
        validationRemarks = "Failed";
        break;
      }
      // if (obj.glCategory === 'Advances') {
      //   if (!obj.projectClass) {
      //     alert(`Project class ${countIndex}: Project class is required`)
      //     validationRemarks = 'Failed'
      //     break
      //   }
      //   const { data } = await getData(
      //     `/api/projectClasses/${obj.projectClass}`
      //   )
      //   console.log(data)
      //   if (data === null) {
      //     alert(
      //       `Project class ${countIndex}: Please make sure that the project class is valid`
      //     )
      //     validationRemarks = 'Failed'
      //     break
      //   }
      // }
      if (obj.glAccount === "") {
        alert(`Project class ${countIndex}: glAccount is required`);
        validationRemarks = "Failed";
        break;
      }
      if (obj.description1 === "") {
        alert(`Project class ${countIndex}: description 1 is required`);
        validationRemarks = "Failed";
        break;
      }
      if (obj.grossPricePerItem === 0) {
        alert(`Project class ${countIndex}: gross price is required`);
        validationRemarks = "Failed";
        break;
      }
      if (obj.vatType === "") {
        alert(`Project class ${countIndex}: vatType is required`);
        validationRemarks = "Failed";
        break;
      }
      if (obj.wTaxType === "") {
        alert(`Project class ${countIndex}: wTaxType is required`);
        validationRemarks = "Failed";
        break;
      }
    }
    return validationRemarks;
  };

  handleSubmitNonPo = async (e, key) => {
    e.preventDefault();
    this.setState({ isLoading: true });
    // document.getElementById('page1').style.display = 'block'
    let array = this.state.projectClass;

    let formData = new FormData();

    let nonPoForm = {
      dueDate: this.state.dueDate,
      department: this.state.requestingDepartment,
      // departmentApprover: '5def0fc26501e01d3c1b3b45',
      vendor: this.state.vendor,
      project: this.state.project,
      projectClasses: this.state.projectClass,
      // dueDate: this.state.dateNeeded,
      subProject: this.state.subProject,
      particulars: this.state.particulars,
      requestType: "Non PO Item",
      status: "For Approval",
      // unitPrice: this.state.unitPrice,
    };

    //validate to view loading
    const fieldToValidate = localValidation(nonPoForm);
    if (fieldToValidate !== null) {
      this.setState({ isLoading: false });
      alert(`${fieldToValidate} is required`);
      return "remainOnFirstPage";
    } else {
      const vendor = await getData(`/api/vendors/${nonPoForm.vendor}`);
      const project = await getData(`/api/projects/${nonPoForm.project}`);
      console.log(nonPoForm.project);
      console.log(project);
      if (vendor.data === null) {
        this.setState({ isLoading: false });
        alert("Please make sure that the vendor is valid");
        return "remainOnFirstPage";
      }
      if (project.data === null) {
        this.setState({ isLoading: false });
        alert("Please make sure that the project is valid");
        return "remainOnFirstPage";
      }
      if (this.state.file === null || this.state.fileErr === 1) {
        this.setState({ isLoading: false });
        alert("Supporting documents is required");
        return "remainOnFirstPage";
      }
      if (key === "fromFirstPage") {
        this.setState({ isLoading: false });
        return;
      }
      const validationProjectClasses = await this.localValidationProjectClasses(
        nonPoForm.projectClasses
      );
      if (validationProjectClasses) {
        this.setState({ isLoading: false });
        return;
      }
      document.getElementById("modalBody").style.display = "block";
    }

    // to split glaccount string to get the accountCode
    for (const index in nonPoForm.projectClasses) {
      const glAccountArray =
        nonPoForm.projectClasses[index].glAccount.split(" ");
      nonPoForm.projectClasses[index].glAccount = glAccountArray[0];
    }

    formData.set("crfForm", JSON.stringify(nonPoForm));
    formData.append("supportingDocuments", this.state.file);
    axios({
      method: "POST",
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm`,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        console.log(response);
        console.log(response.data.Data._id);
        this.setState({
          isLoading: false,
          redirect: true,
          crfId: `/CheckRequest/${response.data.Data._id}`,
        });
        document.getElementById("modalBody").style.display = "none";
        console.log(this.state.redirect);
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        console.log(error.response.data.Error);
        alert("Please complete the fields before submitting");
        document.getElementById("formHintContainer").style.display = "block";
        document.getElementById("errorHint").innerText =
          " " +
          "Please make sure you filled up the required fields at Project Class" +
          " " +
          (parseInt(error.response.data.Error.slice(-1)) + 1);
        // document.getElementById("form-validation-error").innerText = "Please fill out the required fields or check if your input is correct"
      });
  };

  handleDraftNonPo = (e) => {
    // e.preventDefault()
    document.getElementById("page1").style.display = "block";
    let array = this.state.projectClass;

    let formData = new FormData();

    let nonPoForm = {
      department: this.state.requestingDepartment,
      // departmentApprover: '5def0fc26501e01d3c1b3b45',
      vendor: this.state.vendor,
      projectName: this.state.project,
      projectClass: this.state.projectClass,
      dueDate: this.state.dueDate,
      subProject: this.state.subProject,
      particulars: this.state.particulars,
      requestType: "Non PO Item",
      status: "Draft",
      unitPrice: this.state.unitPrice,
    };
    if (
      nonPoForm.department.trim() === "" &&
      nonPoForm.vendor.trim() === "" &&
      nonPoForm.projectName.trim() === "" &&
      nonPoForm.particulars === "" &&
      nonPoForm.subProject.trim() === "" &&
      this.state.file === null
    ) {
      alert("Cannot save empty field");
      return;
    }
    if (nonPoForm.vendor === "") {
      alert("Vendor field cannot be empty when saving");
      return;
    }
    formData.set("crfForm", JSON.stringify(nonPoForm));
    formData.append("supportingDocuments", this.state.file);
    this.setState({
      isLoading: true,
    });
    document.getElementById("modalBody").style.display = "block";
    axios({
      method: "POST",
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/draft`,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        console.log(response);
        this.setState({
          isLoading: false,
          redirect: true,
          crfId: `/Draft/${response.data.data.insertedIds[0]}`,
        });
        console.log(this.state.redirect);
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
        console.log(error.response);
      });
  };

  handleRemoveProjectClass = (e, index) => {
    e.preventDefault();
    const projectClass = [...this.state.projectClass];
    projectClass.splice(index, 1);
    let requestingGrossPrice = 0.0;
    let requestingAmount = 0.0;
    for (let obj of projectClass) {
      requestingGrossPrice =
        parseFloat(obj.subTotalGrossPrice) + parseFloat(requestingGrossPrice);
      requestingAmount =
        parseFloat(obj.subTotalNetPrice) + parseFloat(requestingAmount);
    }
    this.setState({
      projectClass,
      requestingGrossPrice: requestingGrossPrice.toFixed(2),
      requestingAmount: requestingAmount.toFixed(2),
    });
  };

  render() {
    let vatTypeSelections = "";
    // if (this.state.vatTypeSelector == '') {
    vatTypeSelections = (
      <>
        <option value="IVAT-S">IVAT-S</option>
        <option value="IVAT-G">IVAT-G</option>
        <option value="DIV-S">DIV-S</option>
        <option value="DIV-R">DIV-R</option>
        <option value="DIV-L">DIV-L</option>
        <option value="VAT-X">VAT-X</option>
        <option value="VAT-Z">VAT-Z</option>
        <option value="NON-VAT">NON-VAT</option>
        <option value="INT-IV">INT-IV</option>
      </>
    );
    // }
    // else if (this.state.vatTypeSelector == 'IVAT-G') {
    //   vatTypeSelections = (
    //     <>
    //       <option value='None IVAT-X1'>None IVAT-X1</option>
    //       <option value='Goods IVAT-G'>Goods IVAT-G</option>
    //     </>
    //   )
    //   // for (let i = 0; i < this.state.projectClass.length; i++) {
    //   //   this.state.projectClass[i].vatType = "Goods IVAT-G"
    //   // }
    //   // console.log(this.state.projectClass)
    // } else if (this.state.vatTypeSelector == 'IVAT-S') {
    //   vatTypeSelections = (
    //     <>
    //       {/* <option value="" disabled selected hidden>Please Choose...</option> */}
    //       <option value='None IVAT-X1'>None IVAT-X1</option>
    //       <option value='Services IVAT-S'>Services IVAT-S</option>
    //     </>
    //   )
    //   // for (let i = 0; i < this.state.projectClass.length; i++) {
    //   //   this.state.projectClass[i].vatType = "Services IVAT-S"
    //   // }
    //   // console.log(this.state.projectClass)
    // } else if (this.state.vatTypeSelector == 'X1') {
    //   vatTypeSelections = (
    //     <>
    //       <option value='None IVAT-X1'>None IVAT-X1</option>
    //     </>
    //   )
    //   for (let i = 0; i < this.state.projectClass.length; i++) {
    //     this.state.projectClass[i].vatType = 'None IVAT-X1'
    //   }
    //   // console.log(this.state.projectClass)
    // }

    if (this.state.redirect === true) {
      return <Redirect to={this.state.crfId} />;
    }

    return (
      <CrfContext.Consumer>
        {(context) => (
          <form id="mainPage">
            <NonPoModal />
            <div id="sidePanel">
              <SideNav
              // testState = {context.state.testState}
              // toggleBtn1List = {context.toggleBtn1List}
              // toggleBtn2List = {context.toggleBtn2List}
              // btn1List = {context.state.btn1List}
              // btn2List = {context.state.btn2List}
              // userRole = {context.state.userRole}
              />
            </div>
            <div id="mainPanel">
              {/* BANNER */}
              <Transition
                native
                items={this.state.showBanner}
                from={{ opacity: 0, marginTop: -500 }}
                enter={{ opacity: 1, marginTop: 0 }}
                leave={{ opacity: 0, marginTop: -500 }}
                // config={{ duration: 1000 }}
              >
                {(show) =>
                  show &&
                  ((props) => (
                    <animated.div style={props}>
                      <div className="requestFormBanner">
                        <h1>NON PO ITEMS</h1>
                      </div>
                    </animated.div>
                  ))
                }
              </Transition>
              {/* END OF BANNER */}
              {/* FORM */}
              <div className="formContainer">
                <Transition
                  native
                  items={this.state.showForm}
                  from={{ opacity: 0 }}
                  enter={{ opacity: 1 }}
                  leave={{ opacity: 0 }}
                  config={{ duration: 300 }}
                >
                  {(show) =>
                    show &&
                    ((props) => (
                      <animated.div style={props}>
                        <NonPoItemView
                          // userDepartment = {context.state.userDepartment}
                          // vendorLists = {context.state.vendorLists}
                          // projectLists = {context.state.projectLists}
                          // cocExpenses = {context.state.cocExpenses}
                          // advances = {context.state.advances}
                          // ppeAccounts = {context.state.ppeAccounts}
                          // adminExpenses = {context.state.adminExpenses}
                          // advancesProjectClass = {context.state.advancesProjectClass}
                          isProject={context.state.isProject}
                          dueDate={this.state.dueDate}
                          requestingGrossPrice={this.state.requestingGrossPrice}
                          requestingAmount={this.state.requestingAmount}
                          onBlurNumber={this.onBlurNumber}
                          userDeptList={this.state.userDeptList}
                          isLoading={this.state.isLoading}
                          vendor={this.state.vendor}
                          vendorError={this.state.vendorError}
                          vendorErr={this.state.vendorErr}
                          particulars={this.state.particulars}
                          particularsError={this.state.particularsError}
                          particularsErr={this.state.particularsErr}
                          project={this.state.project}
                          projectError={this.state.projectError}
                          projectErr={this.state.projectErr}
                          file={this.state.file}
                          fileError={this.state.fileError}
                          fileErr={this.state.fileErr}
                          projectClass={this.state.projectClass}
                          accountTypes={this.state.accountTypes}
                          vatTypeSelector={this.state.vatTypeSelector}
                          vatTypeSelections={vatTypeSelections}
                          wTaxRates={this.state.wTaxRates}
                          handleChangeRequestField={
                            this.handleChangeRequestField
                          }
                          handleChangeProjectClassValue={
                            this.handleChangeProjectClassValue
                          }
                          addProjectClass={this.addProjectClass}
                          handleSubmitNonPo={this.handleSubmitNonPo}
                          handleDraftNonPo={this.handleDraftNonPo}
                          checkStateValue={this.checkStateValue}
                          file={this.state.file}
                          vendorLists={this.state.vendorLists}
                          projectLists={this.state.projectLists}
                          handleRemoveProjectClass={
                            this.handleRemoveProjectClass
                          }
                          addedProjectClass={this.state.addedProjectClass}
                        />
                      </animated.div>
                    ))
                  }
                </Transition>
              </div>
              {/* END OF FORM */}
            </div>
          </form>
        )}
      </CrfContext.Consumer>
    );
  }
}

const dark = {
  color: "black",
};

export default NonPoItems;
